var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":""}},[_c('v-row',{staticClass:"Arrow",attrs:{"justify":"end"}},[_c('v-btn',{attrs:{"icon":"","to":"blog"}},[_c('v-icon',{attrs:{"color":"grey"}},[_vm._v("fas fa-arrow-left")])],1)],1),_vm._l((_vm.card),function(el){return _c('FillForBlog',{key:el + Math.random(),attrs:{"title":el.name,"content":el.content}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }